import { render, staticRenderFns } from "./EditAlbum.vue?vue&type=template&id=79bcb0ef&"
import script from "./EditAlbum.vue?vue&type=script&lang=js&"
export * from "./EditAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditAlbum.vue"
export default component.exports